<div class="position-relative">
  <ng-container >
    <h2 class="mb-1" mat-dialog-title>Login</h2>

   <div *ngIf="message!=''"  class="row position-relative m-0">
    <div class="col-md-12 error  p-0">
        {{message}}
        <ng-container *ngIf="data.error=='Subscription_Ended'">
            <br><a *ngIf="data.error=='Subscription_Ended'" href="http://dg.infosystrade.com/users/product/1-month/">Subscribe Now</a>
        </ng-container>

    </div>
   </div>

    <button class="no-hover-effect close-btn" mat-button mat-dialog-close>
    <i class="icons-times"></i>
  </button>
</ng-container>
  <ng-container >
    <mat-dialog-content>

        <form [formGroup]="loginForm" novalidate>
            <div class="row">
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput placeholder="User" formControlName="email" />
                        <mat-error *ngIf="loginForm.controls['email'].hasError('required')">
                            User is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput type="password" placeholder="Password" formControlName="password" />
                        <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
                            Password is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="false">
                <div class="col">
                    <mat-checkbox formControlName="rememberme" color="primary">Remember me</mat-checkbox>
                </div>
            </div>
        </form>

    </mat-dialog-content>
  </ng-container>
    <mat-dialog-actions>
      <ng-container >
        <!-- <button mat-raised-button mat-dialog-close>Cancel</button> -->
        <button
         mat-raised-button
          class="full-width"
           [color]="'glb_greenbtn'"

            (click)="onSubmit()">
      Login
    </button>

     </ng-container>

     <div class="row w-100 pt-2 m-0 p-0">
      <div class="col-md-6 p-0">
        <a target="_blank"  href="http://dg.infosystrade.com/users">Create an account</a>
      </div>
      <div class="col-md-6 text-right p-0">
         <a target="_blank" href="http://dg.infosystrade.com/users/lost-password/"> Forgotten password</a>
      </div>
    </div>

    </mat-dialog-actions>

</div>
